import { apiClient, getErrorMessage } from './apiClient'
import type { DashboardStats } from '../types'

export interface UltimosPedidos {
  pedidos: Array<{
    id: string
    createdAt: string
    numero?: string
    cliente: {
      razaoSocial: string
    }
    total: number
    status: string
    industrias: Array<{
      id: string
      industriaId: string
      nomeFantasia: string
      cor?: string
      totalItens: number
    }>
  }>
}

export const dashboardService = {
  async getStats(periodo?: 'hoje' | 'semana' | 'mes' | '90dias'): Promise<DashboardStats> {
    try {
      const params = periodo ? `?periodo=${periodo}` : ''
      const response = await apiClient.get<DashboardStats>(`/dashboard/stats${params}`)
      return response.data
    } catch (error) {
      throw new Error(getErrorMessage(error))
    }
  },

  async getUltimosPedidos(industriaId?: string): Promise<UltimosPedidos> {
    try {
      const params = industriaId ? `?industriaId=${industriaId}` : ''
      const response = await apiClient.get<UltimosPedidos>(`/dashboard/ultimos-pedidos${params}`)
      return response.data
    } catch (error) {
      throw new Error(getErrorMessage(error))
    }
  },
}
